import React, { useState, useEffect, useMemo } from 'react';
// Third-party libraries
import { connect } from "react-redux"
// UI - Material UI
import { Grid } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import DataTable from 'react-data-table-component';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
// Local files
import TableFilterComponentOtherTransactions from '../../common/TableFilterComponentOtherTransactions'
import { ColumnsDetailOrder } from './ColumnsDetailOrder'
import { customStylePrincipalOrder } from '../../common/CommonStyles'
import { FormatNumberMXN } from "../../common/Utils";

const MuiAccordion = withStyles({
    root: {
      "&$expanded": {
        margin: "auto",
        border: '1px solid rgba(125, 155, 193)',
      }
    },
    expanded: {}
  })(Accordion);

const OrderDetailInfoGeneral = ({classes, data, filteredItems, setFilteredItems,  t, ...props}) => {
    // Filtering state
    const [filterText, setFilterText] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [searchButton, setSearchButton] = useState(0);
    //Accodeon component
    const [showComponentGeneral, setShowComponentGeneral] = useState(true);
    const [showComponentDetail, setShowComponentDetail] = useState(true);
    // config of pagination for DataTable
    const paginationOptions = { 
        rowsPerPageText: t('commonMessages.rowsPerPage'), 
        rangeSeparatorText: t('common.to'), 
        selectAllRowsItem: true, 
        selectAllRowsItemText: t('common.all') 
    }

    // Handle to |Accordeon
    const toggleAcordionGeneral = () => {
        setShowComponentGeneral((prev) => !prev);
      };
    const toggleAcordionDetail = () => {
        setShowComponentDetail((prev) => !prev);
    };    


    //Search Actions
    const handleSearchFilter = () => {
        if(data.services == undefined)
            return;
        
        const items = data.services.filter(item =>
            item.row && item.row.toString().includes(filterText.toLowerCase())
            ||  item.vin && item.vin.toString().toLowerCase().includes(filterText.toLowerCase())
            || item.service && item.service.toString().toLowerCase().includes(filterText.toLowerCase())
            || item.subtotal && item.subtotal.toString().toLowerCase().includes(filterText.toLowerCase())
        );
        setFilteredItems(items);
    }

    const subHeaderComponentMemo = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setFilteredItems(data.services);
                setFilterText('');
            }
        }

        return <TableFilterComponentOtherTransactions
            onFilter={e => setFilterText(e.target.value)}
            onClear={handleClear}
            filterText={filterText}
            SearchFilter={handleSearchFilter}
            styles={classes.searchAlign}
            module='OrderDetailInfoGeneral'
            allowTextFilter
            SearchButton={'Visible'}
            allowExportExcel={false}
            showComponentDetail={!showComponentDetail}
        />

    }, [filterText, searchButton, filteredItems,showComponentDetail]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <MuiAccordion defaultExpanded={true} expanded={showComponentGeneral} >
                <AccordionSummary 
                expandIcon={<ExpandMoreIcon />}
                id="panel1a-header"
                style={{backgroundColor:"#789AC1", minHeight:"37px", height:"37px"}}
                IconButtonProps={{ onClick:toggleAcordionGeneral }} 
                >
                    <Typography variant="body2" style={{color: "#fff"}}>{t('OrderDetailDashboard.AccordionGeneralInfo')}</Typography>
                    
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container>
                    <Grid container item xs={12}>
                        <Grid item xs={12} sm={6} md={2}>
                            <Typography variant="body2" ><b>{t(`OrderDetailDashboard.IdOrder`)}</b></Typography>
                            <Typography variant="body2">{data.pymtOrdId}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <Typography variant="body2" ><b>{t(`OrderDetailDashboard.RFCSupplier`)}</b></Typography>
                            <Typography variant="body2">{data.supplierRFC}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            <Typography variant="body2" ><b>{t(`OrderDetailDashboard.NameSupplier`)}</b></Typography>
                            <Typography variant="body2">{data.supplierName}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}> 
                            <Typography variant="body2" ><b>{t(`OrderDetailDashboard.Status`)}</b></Typography>
                            <Typography variant="body2">{data.stateDescription}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} style={{marginTop:20}}>
                        <Grid item xs={12} sm={6} md={2}>
                            <Typography variant="body2" ><b>{t(`OrderDetailDashboard.OrdenDate`)}</b></Typography>
                            <Typography variant="body2">{data.pymtOrdCreationDtStr}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <Typography variant="body2" ><b>{t(`OrderDetailDashboard.Currency`)}</b></Typography>
                            <Typography variant="body2">{data.currencyCode}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            <Typography variant="body2" ><b>{t(`OrderDetailDashboard.Subtotal`)}</b></Typography>
                            <Typography variant="body2">{data.svcSubtotalAmt ? FormatNumberMXN(data.svcSubtotalAmt ?? 0) : ''}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}> 
                        </Grid>
                    </Grid>
                    </Grid>
                </AccordionDetails>
            </MuiAccordion>
            <MuiAccordion  defaultExpanded={true} border={4} expanded={showComponentDetail}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                    style={{backgroundColor:"#789AC1", minHeight:"37px", height:"37px"}}
                    IconButtonProps={{ onClick:toggleAcordionDetail }} >
                    {subHeaderComponentMemo}
                </AccordionSummary>
                <AccordionDetails style={{padding:0}}>
                    <Grid item xs={12} width="100%">
                        <DataTable
                            columns={ColumnsDetailOrder(t)}
                            persistTableHead
                            data={filteredItems}
                            customStyles={customStylePrincipalOrder}
                            highlightOnHover
                            pointerOnHover
                            responsive
                            striped
                            pagination
                            paginationComponentOptions={paginationOptions}
                            noHeader
                            noDataComponent={<p className={classes.marginNoData}>{t('commonMessages.noData')}</p>}
                            />
                    </Grid>
                </AccordionDetails>
            </MuiAccordion>
        </>
    )
}

const mapStateToProps = state => ({
    orderDetails: state.OrderReducer.OrderDetails,
})


const mapDispatchToProps = (dispatch) => {
    return {
        tokenExpired: () => dispatch({ type: "TOKEN_EXPIRED" })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetailInfoGeneral)
